import React from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import ResearchItem, {
  ResearchTypes
} from 'buyside/components/presentation/ResearchItem/researchItem';
import IndexPaginationNav from 'buyside/components/presentation/IndexPaginationNav/indexPaginationNav';
import Link from 'buyside/components/presentation/Link/link';
import LightbulbIcon from 'SVGs/lightbulb';

import { get } from 'buyside/util/lodashAltJs';
import { ideasUrl } from 'buyside/util/urlHelper';

import styles from './userReadingListPageStyles.scss';

const ReadingListIdeas = ({ archivedPage, currentUser }) => {
  const {
    id: currentUserId,
    archivedReadingListItems,
    archivedReadingListItemsCount,
    canViewUserDetails,
    unreadReadingListItems,
    unreadReadingListItemsCount
  } = currentUser;

  const readingListIdeas = archivedPage
    ? archivedReadingListItems.edges
    : unreadReadingListItems.edges;
  const resultCount = archivedPage ? archivedReadingListItemsCount : unreadReadingListItemsCount;

  return (
    <div>
      {resultCount ? (
        <div>
          {readingListIdeas.map(({ node: { idea } }) => (
            <div className={styles.ideaIndexCardArea} key={idea.id}>
              <ResearchItem
                {...idea}
                researchType={ResearchTypes.IDEA}
                showUserDetails={
                  canViewUserDetails ||
                  currentUserId === get(idea, 'user.id') ||
                  get(idea, 'isNonBuyside')
                }
              />
            </div>
          ))}
        </div>
      ) : (
        <div>
          <div className={styles.noContentMsg}>
            <p>
              Add ideas to your reading list from the{' '}
              <Link to={ideasUrl()} className={styles.highlightLink}>
                Ideas Page
              </Link>{' '}
              to make them <strong>easy to find and read later on.</strong>
            </p>
            <Button
              url={ideasUrl()}
              text="Visit Ideas Page"
              icon={LightbulbIcon}
              type={BUTTON_TYPES.PRIMARY}
            />
          </div>
          {!archivedPage ? (
            <div className={styles.readingListExampleImage}>
              <img src="/images/pro/reading_list_example.png" />
            </div>
          ) : null}
        </div>
      )}
      <IndexPaginationNav
        resultCount={resultCount}
        resultLength={readingListIdeas.length}
        resultsPerPage={10}
      />
    </div>
  );
};

export default ReadingListIdeas;
